import React from "react";
import styled from "styled-components";
import { Dialog, Button } from "@vitalsource/vstui";
import { FormattedMessage, useIntl } from "react-intl";
import { useBrand } from "../../../../common/providers/brand/brand-context";
import { UnsafeHtml } from "../../../../common/ui/UnsafeHtml";
import { prettyHTML } from "../../../../common/ui/Styles";

const Styled = {
  OptOut: styled.p`
    font-style: italic;
  `,
  PolicyButtonContainer: styled.div`
    margin-top: 11px;
    margin-bottom: 23px;
  `,
  CustomBody: styled(UnsafeHtml).attrs({ tag: "div" })`
    ${prettyHTML};
  `,
};

export default function CookieDialog({ denyCookies, ...dialogProps }) {
  const intl = useIntl();
  const brand = useBrand();
  const policyUrl =
    brand.getProp("Cookies.url") || intl.formatMessage({ id: "cookies.url" });
  const headerText =
    brand.getProp("Cookies.disableHeaderText") ||
    intl.formatMessage({ id: "cookies.disableEssential" });
  const customBodyHTML = brand.getProp("Cookies.disableDescriptionHTML");

  return (
    <Dialog
      title={headerText}
      primaryActionButton={{
        label: intl.formatMessage({ id: "base.confirmAndDisable" }),
        onClick: denyCookies,
      }}
      secondaryActionButton={{
        label: intl.formatMessage({ id: "base.cancel" }),
        onClick: dialogProps.onRequestClose,
      }}
      size="large"
      alert
      requireInteraction
      {...dialogProps}
    >
      {customBodyHTML ? (
        <Styled.CustomBody>{customBodyHTML}</Styled.CustomBody>
      ) : (
        <>
          <p>
            <FormattedMessage id="cookies.description" />
          </p>
          <Styled.PolicyButtonContainer>
            <Button inline href={policyUrl} target="_blank">
              <FormattedMessage id="cookies.viewPolicy" />
            </Button>
          </Styled.PolicyButtonContainer>
          <Styled.OptOut>
            <FormattedMessage id="cookies.optOut" />
          </Styled.OptOut>
        </>
      )}
    </Dialog>
  );
}
